import { getTracingEvents } from 'utils/amplitude';
import { WEBAPP_GLOBAL_VISITEDPAGE } from 'utils/amplitude/events/global.amplitude';
import {
  WEBAPP_HOMEPAGE_TODO_MARKEDITEMASDONE,
  WEBAPP_HOMEPAGE_TODO_MARKEDITEMASUNDONE,
} from 'utils/amplitude/events/home.amplitude';

export const tracingEvents = getTracingEvents({
  onRouteChange: {
    name: WEBAPP_GLOBAL_VISITEDPAGE,
    data: (data: { url: string; version?: string }) => data,
  },
  onMarkTodoItemAsDone: {
    name: WEBAPP_HOMEPAGE_TODO_MARKEDITEMASDONE,
    data: (data: { name: string }) => data,
  },
  onMarkTodoItemAsUndone: {
    name: WEBAPP_HOMEPAGE_TODO_MARKEDITEMASUNDONE,
    data: (data: { name: string }) => data,
  },
});

export enum HOME_PAGE_STATE {
  SIMULATE_REVENUE_KEY = 'simulatedRevenue',
  CONNECT_BANK_ACCOUNT_KEY = 'connectedBankAccount',
  CROSSBANK_KEY = 'registeredWithCrossBank',
  SOCIAL_SECURITY_KEY = 'joinedSocialSecurityFund',
  PAST_90_DAYS_EXPENSES_KEY = 'uploadedPast90DaysExpenses',
  BUSINESS_COUNTER_BILL_KEY = 'uploadedBusinessCounterBill',
  GEWRBEAMT_KEY = 'registeredWithGewerbeamt',
  FRAGEBOGEN_KEY = 'registeredAsFragebogen',
  ALL_BUSINESS_EXPENSES_KEY = 'uploadedAllBusinessExpenses',
  ENTER_VAT_NUMBER_KEY = 'enteredVATNumber',
  DISMISSED_GET_HELP_WIDGET = 'dismissedGetHelpWidget',
  DISMISSED_MUST_READ_WIDGET = 'dismissedMustReadWidget',
  CLAIM_STARTER_PACK_KEY = 'claimedStarterPack',
  CLAIM_STARTER_DISCOUNT = 'claimedStarterDiscount',
}
